import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { TimeOffTransaction } from '@models/time-off-v3/time-off-transaction.model';
import { TimeOffType } from '@models/time-off-v3/time-off-type.model';
import { TimeOffv3BalanceDisplayOptions } from '@app/types/translatables/time-off-v3-display.options';

export class BalanceColumn extends Column {
    title = 'time-off-v3.balance';
    property = 'balance';
    type: CellDisplay = CellDisplay.string;

    constructor(private timeOffTypes: TimeOffType[]) {
        super();
    }

    getDisplayPropertyValue(transaction: TimeOffTransaction): any {
        const timeOffType: TimeOffType = this.timeOffTypes.find(
            (timeOffType) => timeOffType.id === transaction.timeOffTypeId
        );

        const unit = timeOffType.unitOfTimePlural;
        const balance = Number(timeOffType.displayInHours ? transaction.balanceHours : transaction.balance).toFixed(2);

        const translatableString = `{{ balance }} ${unit}`;

        return TimeOffv3BalanceDisplayOptions[translatableString]
            ? { key: TimeOffv3BalanceDisplayOptions[translatableString], params: { balance: balance } }
            : `${balance} ${unit}`;
    }
}
